import { createDecorator, VueDecorator } from 'vue-class-component';
import { debounce } from './debounce.util';

export const Debounce = (timeout: number): VueDecorator => {
  return createDecorator((options, key) => {
    if (!options.methods) {
      throw new Error(`Debounce Decorator Error`);
    }

    options.methods[key] = debounce(options.methods[key], timeout);
  });
};
